import {deleteLine, deleteNextWord} from './delete.js';

export function yankNextWord(sequencerEngine) {
    return deleteNextWord(sequencerEngine, false);
}

export function yankLine(sequencerEngine) {
    return deleteLine(sequencerEngine, false);
}
